export const STALE_ONE_MINUTE = 1000 * 60;
export const CACHE_DURATION_MINUTES = 1;
